// extracted by mini-css-extract-plugin
module.exports = {"root":"JdPQA","bg":"_20e9D"};